import { SelectionStatus } from './SelectionStatus';

class SelectionStatusWixPatternsPreset {
  readonly unchecked: SelectionStatus = {
    id: 'unchecked',
    toggle: () => this.checked,
    start: () => this.unchecked,
    final: () => this.checked,
    isChecked: false,
    isIndeterminate: false,
  };

  readonly checked: SelectionStatus = {
    id: 'checked',
    toggle: () => this.unchecked,
    start: () => this.unchecked,
    final: () => this.checked,
    isChecked: true,
    isIndeterminate: false,
  };

  readonly indeterminateUnchecked: SelectionStatus = {
    id: 'indeterminateUnchecked',
    toggle: () => this.indeterminate,
    start: () => this.indeterminateUnchecked,
    final: () => this.indeterminateChecked,
    isChecked: false,
    isIndeterminate: false,
  };

  readonly indeterminate: SelectionStatus = {
    id: 'indeterminate',
    toggle: () => this.indeterminateChecked,
    start: () => this.indeterminateUnchecked,
    final: () => this.indeterminateChecked,
    isChecked: true,
    isIndeterminate: true,
  };

  readonly indeterminateChecked: SelectionStatus = {
    id: 'indeterminateChecked',
    toggle: () => this.indeterminateUnchecked,
    start: () => this.indeterminateUnchecked,
    final: () => this.indeterminateChecked,
    isChecked: true,
    isIndeterminate: false,
  };
}

export const selectionStatusWixPatternsPreset =
  new SelectionStatusWixPatternsPreset();
